import { css } from "@emotion/react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { LoadingMessage } from "@/components/LoadingMessage/LoadingMessage"
import { useAuthUser } from "@/hooks/useAuthUser"
import { useIsIncentiveTarget } from "@/hooks/useIsIncentiveTarget"
import { rankDashboardBase, rankDashboardUrl } from "@/utils/urls"

export const RankDashboardPage = () => {
    const navigate = useNavigate()
    const { token } = useAuth()
    const { userId } = useAuthUser(token)
    const { data: incentiveData, isLoading: isIncentiveLoading } =
        useIsIncentiveTarget()
    const [loaded, setLoaded] = useState(false)

    const handleClose = () => {
        if (window.history.length > 1) {
            navigate(-1)
        } else {
            navigate("/schedule", { replace: true })
        }
    }

    useEffect(() => {
        const allowedOrigin = new URL(rankDashboardBase()).origin
        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== allowedOrigin) return
            if (event.data?.action === "close") {
                handleClose()
            }
        }
        window.addEventListener("message", handleMessage)
        return () => window.removeEventListener("message", handleMessage)
    }, [navigate])

    if (!isIncentiveLoading && !incentiveData?.isTarget) {
        return <Navigate to="/schedule" replace />
    }

    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                height: 100dvh;
                background: #f5f5f5;
            `}
        >
            <iframe
                title="ランクダッシュボード"
                src={rankDashboardUrl(userId)}
                onLoad={() => setLoaded(true)}
                css={css`
                    flex: 1;
                    width: 100%;
                    border: none;
                `}
            />
            {!loaded && (
                <div
                    css={css`
                        position: absolute;
                        inset: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #f5f5f5;
                    `}
                >
                    <button
                        onClick={handleClose}
                        css={css`
                            position: absolute;
                            top: 12px;
                            right: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 36px;
                            height: 36px;
                            font-size: 18px;
                            color: white;
                            cursor: pointer;
                            background: rgba(0, 0, 0, 0.5);
                            border: none;
                            border-radius: 50%;
                        `}
                    >
                        ×
                    </button>
                    <LoadingMessage />
                </div>
            )}
        </div>
    )
}
